import { useBooleanFlag } from '@trm/feature-flags/web';

export const useAppleLoginFlag = () => ({
  isAppleLoginEnabled: useBooleanFlag('enable-social-login-apple', false),
});
